import { USER_ROLE } from "Constants/constant";
import {
  insertFormTabChildrenAfterOther,
  isCustomFormCategory,
} from "components/DynamicForms/shared/formCategoryUtils";

/** Distinct from participant CRM custom tabs (50000+) on another route. */
export const CUSTOM_HRM_FORM_CATEGORY_TAB_ID_BASE = 55000;

export const customHrmFormCategoryTabId = (categoryId) =>
  CUSTOM_HRM_FORM_CATEGORY_TAB_ID_BASE + Number(categoryId);

export const isCustomHrmFormCategoryTabId = (tabId) =>
  Number(tabId) >= CUSTOM_HRM_FORM_CATEGORY_TAB_ID_BASE;

export const formCategoryTabFromCustomHrmCategory = (category) => ({
  name: category.name,
  id: customHrmFormCategoryTabId(category.id),
  children: [],
  slug: category.slug,
  categoryUuid: category.uuid,
  isCustomFormCategory: true,
  roleAccess: [
    USER_ROLE.Sp_Admin,
    USER_ROLE.Sp_Standard_User,
    USER_ROLE.Sp_manager,
  ],
});

/** Worker profile Forms tab id is 4; platform "Other" child id is 8. */
export const mergeCustomHrmCategoriesIntoFormsTab = (tabs, customCategories) => {
  if (!customCategories?.length) {
    return tabs;
  }

  const customChildren = customCategories
    .filter(isCustomFormCategory)
    .map(formCategoryTabFromCustomHrmCategory);

  return tabs.map((tab) => {
    if (tab.id !== 4 || !tab.children?.length) {
      return tab;
    }

    const staticChildren = tab.children.filter(
      (child) => !child.isCustomFormCategory
    );

    return {
      ...tab,
      children: insertFormTabChildrenAfterOther(staticChildren, 8, customChildren),
    };
  });
};
